import PhotoSwipeLightbox from "photoswipe-lightbox";

if (!customElements.get("ls-lightbox-gallery")) {
  customElements.define(
    "ls-lightbox-gallery",
    class LsLightboxGallery extends HTMLElement {
      constructor() {
        super();
        this.handleClick = this.handleClick.bind(this);
        this.handleVariantChange = this.handleVariantChange.bind(this);
      }

      connectedCallback() {
        this.links = Array.from(this.querySelectorAll(".lsph__zoom-link"));
        if (this.links.length === 0) return;
        this.section = this.closest("section");
        this.section?.addEventListener("on:variant:change", this.handleVariantChange, true);
        this.selectMedia(this.dataset.selectedMediaId);

        const options = {
          counter: false,
          bgOpacity: 1,
          dataSource: this.links.map((link) => ({
            src: link.href,
            width: Number(link.dataset.pswpWidth),
            height: Number(link.dataset.pswpHeight),
          })),
          pswpModule: () => import("photoswipe"),
        };

        const closeTemplate = document.getElementById("template-icon-close");
        if (closeTemplate) {
          const icon = closeTemplate.content.cloneNode(true).firstElementChild;
          icon.classList.add("pswp__icn");
          options.closeSVG = icon.outerHTML;
        }

        const chevronTemplate = document.getElementById("template-icon-chevron");
        if (chevronTemplate) {
          const next = chevronTemplate.content.cloneNode(true).firstElementChild;
          next.classList.add("pswp__icn");
          options.arrowNextSVG = next.outerHTML;

          const prev = chevronTemplate.content.cloneNode(true).firstElementChild;
          prev.classList.add("pswp__icn", "icon--left");
          options.arrowPrevSVG = prev.outerHTML;
        }

        this.lightbox = new PhotoSwipeLightbox(options);
        this.lightbox.addFilter("thumbEl", (thumbEl, itemData, index) => {
          return this.links[index]?.querySelector("img") || thumbEl;
        });
        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, slide) => {
          const img = this.links[slide.index]?.querySelector("img");
          return img ? img.currentSrc || img.src : placeholderSrc;
        });
        this.lightbox.init();

        this.links.forEach((link, index) => {
          link.dataset.lightboxIndex = index;
          link.addEventListener("click", this.handleClick);
        });
      }

      disconnectedCallback() {
        this.section?.removeEventListener("on:variant:change", this.handleVariantChange, true);
        if (this.lightbox) {
          this.lightbox.destroy();
          this.lightbox = null;
        }
        if (this.links) {
          this.links.forEach((link) => link.removeEventListener("click", this.handleClick));
        }
      }

      handleVariantChange(event) {
        this.selectMedia(event.detail?.variant?.featured_media?.id);
      }

      selectMedia(mediaId) {
        if (!mediaId) return;
        const selected = Array.from(this.children).find(
          (item) => item.dataset.mediaId === String(mediaId)
        );
        if (!selected) return;
        this.querySelector(".lsph__media-item--main")?.classList.remove("lsph__media-item--main");
        selected.classList.add("lsph__media-item--main");
        const image = selected.querySelector("img");
        if (image) image.loading = "eager";
        this.prepend(selected);
      }

      handleClick(event) {
        event.preventDefault();
        this.lightbox.loadAndOpen(Number(event.currentTarget.dataset.lightboxIndex));
      }
    }
  );
}
